import { BlockGeolocation } from '../utils/local-storage';
import { writable } from 'svelte/store';

const blockGeolocation = writable(BlockGeolocation.get());
blockGeolocation.subscribe(BlockGeolocation.set);

export default blockGeolocation;
